import mapValues from 'lodash/mapValues';
import Immutable from 'seamless-immutable';

import { INITIALIZE_DATAKEY, SET_MODEL, SET_MODEL_PROPERTY } from '../actions/types';
import { Model, ModelValue } from '../types';

export const initialState = Immutable<{
	[dataKey: string]: Model<string> | undefined;
}>({});

// We want all null or undefined values to become the empty string,
// as React treats null or undefined values as uncontrolled inputs,
// which we never want in a useForm context
const coerceNonControllingValue = (value?: ModelValue | null): ModelValue =>
	typeof value === 'undefined' || value === null ? '' : value;
const coerceNonControllingValues = (inputModel: Model<string>): Model<string> =>
	mapValues(inputModel, coerceNonControllingValue);

const modelsReducer = (
	state = initialState,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action: { [key: string]: any },
): Immutable.ImmutableObject<{
	[dataKey: string]: Model<string> | undefined;
}> => {
	const { dataKey, model, initialModel, name, value } = action.payload || {};

	switch (action.type) {
		case INITIALIZE_DATAKEY:
			return state.setIn([dataKey], coerceNonControllingValues(initialModel));

		case SET_MODEL:
			return state.setIn([dataKey], coerceNonControllingValues(model));

		case SET_MODEL_PROPERTY:
			return state.setIn([dataKey, name], coerceNonControllingValue(value));

		default:
			return state;
	}
};

export default modelsReducer;
